/**
 * Loan Settlement screen (/pawn/settlement).
 *
 * A settlement IS a receipt — same customer, same ornaments, same interest
 * engine, same ledger posting. The only differences are that it collects the
 * ENTIRE outstanding balance, its voucher is numbered "H…", and it stamps the
 * loan settled. So rather than a second 5,000-line copy of the receipt sheet
 * that would drift out of step with it, this screen is the receipt sheet
 * mounted in settlement mode: green chrome instead of blue, settlement on from
 * the moment it loads, and no way to post an ordinary part-payment from here.
 *
 * The old flow put a "Settle" button on the receipt screen, revealed only once
 * the remaining principal dropped below a configured threshold. That hid the
 * option precisely when a customer turned up to clear a big loan in one lump
 * sum, so the threshold setting and the button are both gone — settling is now
 * its own counter, exactly as it was in the legacy app.
 */
import React from "react";
import PawnReceiptScreen from "./PawnReceiptScreen";

const PawnSettlementScreen = () => <PawnReceiptScreen settlement />;

export default PawnSettlementScreen;
